export const m5l2Solution = `%lang starknet

// Resources
// https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#registers
// https://www.cairo-lang.org/docs/how_cairo_works/functions.html#function-arguments-and-return-values

// Cairo memory is immutable.
// Once a memory cell has been assigned, its value CANNOT be changed.
// The program will crash if someone tries to assign a new, different, value to an already initialized memory cell.
// However, trying to assign a memory cell twice, or more, **with the same value** won't cause any harm.
// This property can be used to assert the value of a cell.
// do not modify code on this line or above

// Rewrite this function in a high level syntax, using tempvar and assert
func crash() {
    // [ap] = 42; ap++
    // [ap - 1] = 42
    // [ap - 1] = 21
    tempvar x = 42;
    assert x = 42;
    assert x = 21;
    ret;
}

// Rewrite this funtion in a low level syntax
func assert_42(number : felt) {
    // assert number = 42
    [fp -3] = 42;
    return ();
}

// Write this function body so:
// if the memory cell pointed by p_number is not initialized, set it to 42
// else, if the value is initialized and different from 42, crash
// else, do nothing and return
func assert_pointer_42(p_number : felt*) {
    assert [p_number] = 42;
    return ();
}

// Write this function body so:
// if the memory cell pointed by p_number is set to 42, do nothing and return
// else crash
func assert_pointer_42_no_set(p_number : felt*) {
    assert 42 = [p_number];
    return ();
}

// do not modify code on this line or below

from starkware.cairo.common.alloc import alloc

@external
func test_crash() {
    %{ expect_revert() %}
    crash();

    return ();
}

@external
func test_assert_42() {
    assert_42(42);

    %{ expect_revert() %}
    assert_42(21);

    return ();
}

@external
func test_assert_pointer_42_initialized() {
    let (mem_zone : felt*) = alloc();
    assert mem_zone[0] = 42;
    assert mem_zone[1] = 21;

    assert_pointer_42(mem_zone);

    %{ expect_revert() %}
    assert_pointer_42(mem_zone + 1);

    return ();
}

@external
func test_assert_pointer_42_not_initialized_ok() {
    let (mem_zone : felt*) = alloc();
    assert mem_zone[0] = 42;
    assert_pointer_42(mem_zone);

    assert_pointer_42(mem_zone + 1);
    assert mem_zone[1] = 42;

    return ();
}

@external
func test_assert_pointer_42_not_initialized_revert() {
    let (mem_zone : felt*) = alloc();
    assert mem_zone[0] = 42;
    assert_pointer_42(mem_zone);

    assert_pointer_42(mem_zone + 1);
    %{ expect_revert() %}
    assert mem_zone[1] = 21;

    return ();
}

@external
func test_assert_pointer_42_no_set() {
    let (mem_zone : felt*) = alloc();
    assert mem_zone[0] = 42;

    assert_pointer_42_no_set(mem_zone);

    let (mem_zone1 : felt*) = alloc();
    assert mem_zone1[0] = 21;
    %{ expect_revert() %}
    assert_pointer_42_no_set(mem_zone1);

    return ();
}

@external
func test_assert_pointer_42_no_set_crash() {
    let (mem_zone : felt*) = alloc();

    %{ expect_revert() %}
    assert_pointer_42_no_set(mem_zone);

    return ();
}`;
